import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Check, GitMerge, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { ServicePicker } from "@/components/ServiceSearch";
import { IconPicker, GroupInput } from "@/components/admin/AdminServices";

function SuggestionCard({ s, meta, reload }) {
  const [f, setF] = useState({ name: s.name, group: "Serviços Gerais", icon: "wrench" });
  const [merge, setMerge] = useState("");
  const act = async (path, body) => {
    try { await api.post(`/admin/suggestions/${s.id}/${path}`, body); toast.success("Sugestão resolvida"); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="po-card space-y-3" data-testid={`admin-suggestion-${s.id}`}>
      <div>
        <p className="text-xl font-bold text-slate-900">“{s.name}”{s.is_test && <span className="ml-2 rounded bg-slate-200 px-2 text-sm">teste</span>}</p>
        <p className="text-base text-slate-600">{s.user_name} · {s.user_email} · {new Date(s.created_at).toLocaleDateString("pt-BR")}</p>
      </div>
      <div className="rounded-2xl bg-slate-50 p-3">
        <p className="mb-2 font-semibold">Aprovar como nova categoria</p>
        <div className="grid gap-2 sm:grid-cols-2">
          <input className="po-input min-h-[48px]" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid={`admin-suggestion-name-${s.id}`} />
          <GroupInput groups={meta.groups} value={f.group} onChange={(group) => setF({ ...f, group })} testId={`admin-suggestion-group-${s.id}`} />
        </div>
        <div className="mt-2"><IconPicker icons={meta.icons} value={f.icon} onChange={(icon) => setF({ ...f, icon })} testId={`admin-suggestion-icons-${s.id}`} /></div>
        <button onClick={() => act("approve", { ...f, active: true })} className="po-btn-green mt-2 min-h-[48px] text-base" data-testid={`admin-suggestion-approve-${s.id}`}><Check className="h-5 w-5" /> Aprovar</button>
      </div>
      <div className="rounded-2xl bg-slate-50 p-3">
        <p className="mb-2 font-semibold">Ou mesclar com uma categoria existente</p>
        <ServicePicker value={merge} onChange={setMerge} testId={`admin-suggestion-merge-${s.id}`} />
        <button disabled={!merge} onClick={() => act("merge", { slug: merge })} className="po-btn-dark mt-2 min-h-[48px] text-base" data-testid={`admin-suggestion-merge-btn-${s.id}`}><GitMerge className="h-5 w-5" /> Mesclar</button>
      </div>
      <button onClick={() => act("reject")} className="po-btn-outline min-h-[48px] text-base text-red-600" data-testid={`admin-suggestion-reject-${s.id}`}><X className="h-5 w-5" /> Recusar</button>
    </div>
  );
}

export default function AdminSuggestions() {
  const qc = useQueryClient();
  const { data = [] } = useQuery({ queryKey: ["admin-suggestions"], queryFn: () => api.get("/admin/suggestions").then((r) => r.data) });
  const { data: meta } = useQuery({ queryKey: ["admin-services"], queryFn: () => api.get("/admin/services").then((r) => r.data) });
  const reload = () => ["admin-suggestions", "admin-services", "services", "admin-overview", "admin-providers"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
  if (!meta) return null;
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      {data.length === 0 && <p className="text-lg text-slate-600" data-testid="admin-suggestions-empty">Nenhuma sugestão pendente.</p>}
      {data.map((s) => <SuggestionCard key={s.id} s={s} meta={meta} reload={reload} />)}
    </div>
  );
}
